// generic reorder function
export function reorder<Type>(
  items: Type[],
  sourceIndex: number,
  destinationIndex: number
): Type[] {
  const result: Type[] = [...items];
  const [removed] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, removed);
  return result;
}
